var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import RecipientTypeGroup from './parts/RecipientTypeGroup';
import { useIntl } from 'react-intl';
import messages from './emailMessages';
var EmailRecipients = function (_a) {
    var value = _a.value, addresses = _a.addresses, employees = _a.employees, onChange = _a.onChange;
    var intl = useIntl();
    var handleAdd = useCallback(function (type) {
        onChange(type, __spreadArray(__spreadArray([], value[type], true), [''], false));
    }, [onChange, value]);
    var handleChange = useCallback(function (type, index, newValue) {
        onChange(type, value[type].map(function (x, index2) { return (index !== index2 ? x : newValue || ''); }));
    }, [onChange, value]);
    var handleRemove = useCallback(function (type, index) {
        onChange(type, value[type].filter(function (_, index2) { return index !== index2; }));
    }, [onChange, value]);
    return (_jsxs(_Fragment, { children: [_jsx(RecipientTypeGroup, { label: intl.formatMessage(messages.SendTo), type: "to", employeeType: "empTo", addresses: addresses, employees: employees, values: value.to, employeeValues: value.empTo, showRemoveButton: value.to.length + value.empTo.length > 1, onAdd: handleAdd, onChange: handleChange, onRemove: handleRemove, intl: intl }), _jsx(RecipientTypeGroup, { label: intl.formatMessage(messages.Cc), type: "cc", employeeType: "empCc", addresses: addresses, employees: employees, values: value.cc, employeeValues: value.empCc, showRemoveButton: true, onAdd: handleAdd, onChange: handleChange, onRemove: handleRemove, intl: intl }), _jsx(RecipientTypeGroup, { label: intl.formatMessage(messages.Bcc), type: "bcc", employeeType: "empBcc", addresses: addresses, employees: employees, values: value.bcc, employeeValues: value.empBcc, showRemoveButton: true, onAdd: handleAdd, onChange: handleChange, onRemove: handleRemove, intl: intl })] }));
};
export default EmailRecipients;
